export const normalizePhoneDigits = (value = "") => String(value).replace(/\D/g, "");

export const normalizeDialCode = (value = "") => {
  const digits = normalizePhoneDigits(value);
  return digits ? `+${digits}` : "";
};

export const validateLocalMobile = ({
  mobile = "",
  countryCode = "",
  minLength = 4,
  maxLength = 15,
} = {}) => {
  const digits = normalizePhoneDigits(mobile);

  if (!digits) {
    return "Enter your Mobile Number";
  }

  if (countryCode === "IN") {
    return digits.length === 10
      ? ""
      : "Enter a valid 10-digit Indian Mobile Number";
  }

  if (digits.length < minLength || digits.length > maxLength) {
    return "Enter a valid Mobile Number";
  }

  return "";
};

export const buildPhonePayload = ({
  mobile = "",
  dialcode = "",
  countryCode = "",
  minLength = 4,
  maxLength = 15,
} = {}) => {
  const normalizedMobile = normalizePhoneDigits(mobile);
  const normalizedDialCode = normalizeDialCode(dialcode);
  const error = validateLocalMobile({
    mobile: normalizedMobile,
    countryCode,
    minLength,
    maxLength,
  });

  if (error) {
    return {
      ok: false,
      error,
      payload: null,
    };
  }

  const dialDigits = normalizePhoneDigits(normalizedDialCode);
  if (dialDigits && normalizedMobile === dialDigits) {
    return {
      ok: false,
      error: "Enter your Mobile Number without country code",
      payload: null,
    };
  }

  return {
    ok: true,
    error: "",
    payload: {
      mobileno: normalizedMobile,
      dialcode: normalizedDialCode,
    },
  };
};

export const samePhoneDetails = ({
  firstMobile = "",
  firstDialCode = "",
  secondMobile = "",
  secondDialCode = "",
} = {}) =>
  normalizePhoneDigits(firstMobile) === normalizePhoneDigits(secondMobile) &&
  normalizeDialCode(firstDialCode) === normalizeDialCode(secondDialCode);
